import { QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { useQuery } from 'react-query';
import { useUserData } from '@24i/nxg-sdk-smartott-shared/src/context/UserData';

export const useEnrichedAnalytics = (originalAnalytics) => {
    const userDataClient = useUserData();
    const { data: user } = useQuery(QUERY_KEYS.user, userDataClient.fetchUser);

    return (trigger, payload) => {
        const newParams = { ...payload, user };
        originalAnalytics(trigger, newParams);
    };
};
